import axios from "axios";
import accounts from "../../models/cuentasCorrientes/accounts";
import accountWithRelations from "../../models/cuentasCorrientes/accountWithRelations";
import movementsModel from "@/models/cuentasCorrientes/Relations/movements.js";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAccounts() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/cuentas`, { headers }).then(({ data }) =>
      data.map((item) => {
        return accounts.fromJson(item);
      })
    );
  }

  getAccountId(accountId) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/cuentas/${accountId}`, { headers })
      .then(({ data }) => {
        return accountWithRelations.fromJson(data[0]);
      });
  }

  add(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .post(`${url}/cuentas`, payload, { headers })
      .then(({ data }) => {
        return accounts.fromJson(data);
      });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {};

    if (data.hasOwnProperty("name")) {
      payload.nombre = data.name;
    }

    if (data.hasOwnProperty("description")) {
      payload.descripcion = data.description;
    }

    if (data.hasOwnProperty("unit")) {
      payload.unidad = data.unit;
    }

    return axios
      .patch(`${url}/cuentas/${data.accountId}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  delete(accountId) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/cuentas/${accountId}`, { headers });
  }

  //Conceptos
  addConceptToAccount(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      cuentaId: data.accountId,
      conceptos: data.conceptos,
      csCostoId: Number(data.csCostoId),
      paramA: Number(data.paramA),
      paramB: Number(data.paramB),
      debCred: data.debCred,
      formula: data.formula,
    };

    return axios.post(`${url}/cuentas/conceptos`, payload, { headers });
  }

  editConceptToAccount(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.hasOwnProperty("costCenterId")) {
      payload.csCostoId = data.costCenterId;
    }
    if (data.hasOwnProperty("debCred")) {
      payload.debCred = data.debCred;
    }
    if (data.hasOwnProperty("formula")) {
      payload.formula = data.formula;
    }
    if (data.hasOwnProperty("paramA")) {
      payload.paramA = data.paramA;
    }
    if (data.hasOwnProperty("paramB")) {
      payload.paramB = data.paramB;
    }

    return axios.patch(
      `${url}/cuentas/${data.accountId}/concepto/${data.conceptId}&${data.oldCostCenterId}`,
      payload,
      { headers }
    );
  }

  deleteConceptToAccount(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/cuentas/${data.accountId}/concepto/${data.conceptId}`,
      { headers }
    );
  }

  //empleados
  addEmployeesToAccount(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      cuentaId: data.accountId,
      empleados: data.employees,
      topeMax: Number(data.topeMax),
      topeMin: Number(data.topeMin),
      fecDesde:
        moment.utc(data.dateStart).format("YYYY-MM-DD") + "T00:00:00.000Z",
      fecHasta:
        data.dateEnd === null
          ? undefined
          : moment.utc(data.dateEnd).format("YYYY-MM-DD") + "T00:00:00.000Z",
    };

    return axios.post(`${url}/cuentas/empleados`, payload, { headers });
  }

  editEmployeesToAccount(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.hasOwnProperty("topeMin")) {
      payload.topeMin = data.topeMin;
    }
    if (data.hasOwnProperty("topeMax")) {
      payload.topeMax = data.topeMax;
    }
    if (data.hasOwnProperty("dateStartInput")) {
      payload.fecDesde =
        moment.utc(data.dateStartInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    if (data.hasOwnProperty("dateEndInput")) {
      payload.fecHasta =
        moment.utc(data.dateEndInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.patch(
      `${url}/cuentas/${data.accountId}/empleado/${data.empId}&${data.fecDesdeOld}`,
      payload,
      { headers }
    );
  }

  deleteEmployeesToAccount(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/cuentas/${data.accountId}/empleado/${data.empId}&${data.dateStartInput}`,
      { headers }
    );
  }

  addMovementToAccount(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      conceptoId: Number(data.conceptId),
      csCostoId: Number(data.csCostoId),
      cantidad: Number(data.cantidad),
      cuentaId: data.accountId,
      empId: data.empId,
      fechaLiq:
        moment.utc(data.fechaLiq).format("YYYY-MM-DD") + "T00:00:00.000Z",
      comentario: data.comentario,
    };

    return axios.post(`${url}/cuentas/movimientos`, payload, { headers });
  }

  getMovements(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(
        `${url}/cuentas/empleados/movim/${data.empId}&${data.accountId}&${data.dateStart}`,
        { headers }
      )
      .then(({ data }) => {
        if (!Array.isArray(data)) {
          return [];
        }
        return data.map((item) => {
          return movementsModel.fromJson(item);
        });
      });
  }

  initializeMassive(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      cantidad: Number(data.cantidad),
      cuentaId: data.cuentaId,
    };

    return axios.post(`${url}/cuentas/inicializacion`, payload, { headers });
  }
}

export default service;
